module.exports = __webpack_public_path__ + "static/img/kj1-1.7b0596c.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/sougou/kj1-1.png
// module id = 428
// module chunks = 0